<template>
    <div class="container">
        <v-card-title class="titulopagina">IMPORTAR TRAZA</v-card-title>
        <v-row>
            <v-tabs
                background-color="blue accent-3"
                class="elevation-2"
                dark
                :centered="true"
                :grow="true"
                :vertical="false"
                :right="false"
                prev-icon="mdi-arrow-left-bold-box-outline"
                next-icon="mdi-arrow-right-bold-box-outline"
                :icons-and-text="true"
                >
                <v-tabs-slider></v-tabs-slider>

                <!-- tab importar Excel -->
                <v-tab :href="`#tab-importar-excel`" >
                    Importar Datos
                    <v-icon>publish</v-icon>
                </v-tab>

                <v-tab-item :value="'tab-importar-excel'" >
                    <v-card flat tile >
                        <v-row>
                            <v-col>
                                <v-card-text color="teal darken-2" class="text-center">Importar Excel</v-card-text>
                                <v-card-text>
                                    <v-row>
                                        <v-col>
                                            <v-file-input
                                                id="input_archivo"
                                                @change="cambioArchivo"
                                                v-model="archivo" 
                                                label="Importar Excel" 
                                                accept=".xlsx, .xls"
                                                outlined 
                                                dense>
                                            </v-file-input>
                                        </v-col>
                                        <v-col>
                                            <v-text-field
                                                v-model="skip"
                                                label="Fila comienzo importación"
                                                type="number"
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col>
                                            <v-text-field
                                                v-model="limit"
                                                label="Cantidad registros a importar (máximo 30)"
                                                type="number"
                                                dense
                                            ></v-text-field>
                                        </v-col>
                                        <v-col>
                                            <v-btn color="green darken-1"  :dark="!desactivar_importar" :disabled="desactivar_importar" @click="importarDatos"><v-icon>publish</v-icon></v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-text>
                                    <alert></alert>
                                </v-card-text>
                            </v-col>
                        
                        </v-row>
                    </v-card>
                    <v-card class="pa-2">
                        <v-row>
                            <v-col v-if="datos.length > 0" class="text-center py-6">
                                <v-btn color="green darken-1" @click="guardarRegistros" dark>Guardar datos<v-icon>save</v-icon></v-btn>
                            </v-col>
                        </v-row>
                        <v-data-table 
                            :headers="cabeceras_datos"
                            :items="nuevos_datos"
                            :items-per-page="10"
                            class="elevation-2 mt-1"
                            dense
                        > 
                            <template v-slot:header="{ headers }">
                                <thead>
                                    <tr class="text-h6">
                                        <th class="py-1 cabecera cabecera-traslado" colspan="10">Ingresos por Traslado</th>
                                        <th class="py-1 cabecera cabecera-reensaque" colspan="11">Ingresos/Salidas por Reensaque</th>
                                        <th class="py-1 cabecera cabecera-saldo" colspan="2">Saldos de Embarques</th>
                                        <th class="py-1 cabecera cabecera-venta" colspan="15">Ventas/Exportación</th>
                                    </tr>
                                    <tr v-for="header in headers">
                                        <th :class="header.class">{{ header.text }}</th>
                                    </tr>
                                </thead>
                            </template>
                            <!-- INGRESO POR TRASLADO -->
                            <template v-slot:item.id="{ item }">
                                <td>
                                    <span>{{ item.id }}</span>
                                    <v-checkbox
                                        v-if="item.existe_lote"
                                        v-model="item.seleccionado.traslado"
                                        @click="seleccionar(item, 'traslado')"
                                    ></v-checkbox>
                                </td>
                            </template>
                            <template v-slot:item.nuevo_lote="{ item }">
                                <td>
                                    <span v-if="item.leyenda">{{ item.leyenda }}</span>
                                    <v-text-field
                                        v-else-if="nuevo_lote[item.lote]"    
                                        v-model="leyendas[item.lote]"
                                        :error-messages="item.nro_maxis_2_options.length === 0 ? 'Faltan maxis en columna R' : ''"
                                    ></v-text-field>
                                    <span v-else>No aplica</span>
                                </td>
                            </template>
                            <template v-slot:item.lote="{ item }">
                                <td :class="`${!item.existe_lote && 'lote-inexistente'}`" :style="{backgroundColor: `${item.color}`}">
                                    <span class="d-flex justify-center">
                                        {{ item.lote }}
                                        <v-icon color="blue" class="ml-3" title="Agregar lotes restantes" @click="obtenerLotesRestantes(item)">info</v-icon>
                                    </span>
                                </td>
                            </template>
                            <template v-slot:item.maxis="{ item }">
                                <td>
                                    <v-select
                                        :label="item.maxis"
                                        :items="item.maxis_options"
                                        v-model="item.maxis_seleccionados"
                                        multiple
                                        small-chips
                                    ></v-select>
                                </td>
                            </template>

                            <!-- REENSAQUE -->
                            <template v-slot:item.fecha_reensaque="{ item }">
                                <td>
                                    <span>{{ item.fecha_reensaque | formatearFecha }}</span>
                                    <v-checkbox
                                        v-if="item.existe_lote"
                                        v-model="item.seleccionado.reensaque"
                                        @click="seleccionar(item, 'reensaque')"
                                    ></v-checkbox>
                                </td>
                            </template>
                            <template v-slot:item.formato="{ item }">
                                <td>
                                    <v-select
                                        :label="`Formato de maxisacos (${item.formato})`"
                                        :items="formatos_maxisacos"
                                        item-text="formato"
                                        item-value="id"
                                        v-model="item.formato_maxisaco"
                                    ></v-select>
                                </td>
                            </template>
                            <template v-slot:item.nro_maxis_2="{ item }">
                                <td>
                                    <v-select
                                        :label="item.nro_maxis_2"
                                        :items="item.nro_maxis_2_options"
                                        v-model="item.nro_maxis_2_seleccionados"
                                        multiple
                                        small-chips
                                    ></v-select>
                                </td>
                            </template>

                            <!-- VENTA O EXPORTACIÓN -->

                            <template v-slot:item.nro_embarque_2="{ item }">
                                <td>
                                    <span>{{ item.nro_embarque_2 }}</span>
                                    <v-checkbox
                                        v-if="item.existe_lote"
                                        v-model="item.seleccionado.venta"
                                        @click="seleccionar(item, 'venta')"
                                    ></v-checkbox>
                                </td>
                            </template>
                            <template v-slot:item.fecha_despacho="{ item }">
                                <td>{{ item.fecha_despacho | formatearFecha }}</td>
                            </template>
                            <!-- SALDO -->
                            <template v-slot:item.saldo="{ item }">
                                <v-text-field  
                                    type="number"  
                                    v-model="item.saldo"
                                ></v-text-field>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-tab-item>
                <!-- tab importar Excel -->

        </v-tabs>
        </v-row>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import Alert from '@/components/shared/Alert.vue';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    data: () => ({
        skip: null,
        limit: null,
        url_archivo: null,
        archivo:{},
        formatos_aceptados:['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/wps-office.xlsx','application/vnd.ms-excel'],
        formatos_maxisacos: [],
        mov_documentos: [],
        datos: [],
        leyendas: {},
        nuevo_lote: {},
        colores: {},
        cabeceras_datos: [
            // INGRESO POR TRASLADO (10)
            { text: 'ID', align: 'center', sortable: true, value: 'id', class: 'cabecera cabecera-traslado',}, // Número 
            { text: 'Leyenda Nuevo Lote', align: 'center', sortable: true, value: 'nuevo_lote', class: 'cabecera cabecera-traslado', width: "120px"}, // Leyenda Nuevo Lote
            { text: 'Nro Embarque', align: 'center', sortable: true, value: 'nro_embarque', class: 'cabecera cabecera-traslado',}, // Col A
            { text: 'Lote', align: 'center', sortable: true, value: 'lote', class: 'cabecera cabecera-traslado',}, // Col B
            { text: 'Fecha Prod.', align: 'center', sortable: true, value: 'fp', class: 'cabecera cabecera-traslado',}, // Col C
            { text: 'Maxi', align: 'center', sortable: true, value: 'maxi', class: 'cabecera cabecera-traslado',}, // Col D
            { text: 'Tonelada', align: 'center', sortable: true, value: 'tonelada', class: 'cabecera cabecera-traslado',}, // Col E
            { text: 'PAC/NO PAC', align: 'center', sortable: true, value: 'pac', class: 'cabecera cabecera-traslado',}, // Col G
            { text: 'Línea', align: 'center', sortable: true, value: 'linea', class: 'cabecera cabecera-traslado',}, // Col H
            { text: 'Maxis', align: 'center', sortable: true, value: 'maxis', class: 'cabecera cabecera-traslado', width: "420px"}, // Col K (select)
            
            // SALIDA-INGRESO REENSAQUE (10)
            { text: 'Fecha Reensaque', align: 'center', sortable: true, value: 'fecha_reensaque', class: 'cabecera cabecera-reensaque',}, // Col I
            { text: 'Guía Provisional', align: 'center', sortable: true, value: 'guia_provisional', class: 'cabecera cabecera-reensaque',}, // Col I
            { text: 'Tonelada Inicial', align: 'center', sortable: true, value: 'tonelada_inicial', class: 'cabecera cabecera-reensaque',}, // Col N
            { text: 'Incremento', align: 'center', sortable: true, value: 'incremento', class: 'cabecera cabecera-reensaque',}, // Col J
            { text: 'Lote', align: 'center', sortable: true, value: 'lote_2', class: 'cabecera cabecera-reensaque',}, // Col L
            { text: 'FP', align: 'center', sortable: true, value: 'fp_2', class: 'cabecera cabecera-reensaque',}, // Col M
            { text: 'Formato', align: 'center', sortable: true, value: 'formato', class: 'cabecera cabecera-reensaque', width: "200px"}, // Col O
            { text: 'Total Maxis', align: 'center', sortable: true, value: 'total_maxis', class: 'cabecera cabecera-reensaque',}, // Col P
            { text: 'Nro. Maxis (R)', align: 'center', sortable: true, value: 'nro_maxis_2', class: 'cabecera cabecera-reensaque', width: "420px"}, // Col R
            { text: 'Nro. Maxis (T)', align: 'center', sortable: true, value: 'nro_maxis', class: 'cabecera cabecera-reensaque', width: "420px"}, // Col T (select)
            { text: 'Maxis x guía', align: 'center', sortable: true, value: 'maxis_guia', class: 'cabecera cabecera-reensaque',}, // Col U
            
            // SALDO (2)
            { text: 'Saldo', align: 'center', sortable: true, value: 'saldo', class: 'cabecera cabecera-saldo', width: "150px"}, // Col W
            { text: 'Folio', align: 'center', sortable: true, value: 'folio_prod', class: 'cabecera cabecera-saldo',}, // Col AD

            // VENTA O EXPORTACIÓN (15)
            { text: 'Nro Embarque (2)', align: 'center', sortable: true, value: 'nro_embarque_2', class: 'cabecera cabecera-venta',}, // Col AJ
            { text: 'Guia', align: 'center', sortable: true, value: 'guia', class: 'cabecera cabecera-venta',}, // Col AO

            { text: 'Mercado Destino', align: 'center', sortable: true, value: 'mercado_destino', class: 'cabecera cabecera-venta',}, // Col AH
            { text: 'Fecha Despacho', align: 'center', sortable: true, value: 'fecha_despacho', class: 'cabecera cabecera-venta',}, // Col AI
            { text: 'Ubicación Producto', align: 'center', sortable: true, value: 'ubicacion_producto', class: 'cabecera cabecera-venta',}, // Col AL
            { text: 'Puerto', align: 'center', sortable: true, value: 'puerto', class: 'cabecera cabecera-venta',}, // Col AP
            { text: 'Folio Destino Embarque', align: 'center', sortable: true, value: 'folio_dest_embarque', class: 'cabecera cabecera-venta',}, // Col AQ
            { text: 'AOCS/SMAE', align: 'center', sortable: true, value: 'aocs_smae', class: 'cabecera cabecera-venta',}, // Col AR
            { text: 'Neppex', align: 'center', sortable: true, value: 'neppex', class: 'cabecera cabecera-venta',}, // Col AS
            { text: 'Contenedor', align: 'center', sortable: true, value: 'contenedor', class: 'cabecera cabecera-venta',}, // Col AV
            { text: 'Medio Transporte', align: 'center', sortable: true, value: 'medio_transporte', class: 'cabecera cabecera-venta',}, // Col AW
            { text: 'Ubicación Certificado', align: 'center', sortable: true, value: 'ubicacion_certificado', class: 'cabecera cabecera-venta',}, // Col AX
            { text: 'Presentación', align: 'center', sortable: true, value: 'presentacion', class: 'cabecera cabecera-venta',}, // Col AZ
            { text: 'Bultos Asociados', align: 'center', sortable: true, value: 'bultos_asociados', class: 'cabecera cabecera-venta',}, // Col BA
            { text: 'Cliente', align: 'center', sortable: true, value: 'cliente', class: 'cabecera cabecera-venta',}, // Col BC
            
        ]
    }),

    mounted() {
        this.cargarFormatos();
        this.cargarDocumentos();
    }, 

    methods: {
        cambioArchivo() {
            console.log('archivo',this.archivo);
            const conf = {};
            // busca entre los formatos aceptados
            const aceptado = this.formatos_aceptados.find(formato => formato === this.archivo.type);
            
            if(aceptado == undefined){
                /* Solo se acepta archivos excel */
                this.archivo = {};
                conf.tipo = "error";
                conf.mensaje = " Formato de archivo no leído. Pruebe a generar el formato y a copiar la información en ese archivo: " + this.archivo.type
                Event.$emit('mostrar_alert', conf);
            } else {
                conf.tipo = "success";
                conf.mensaje = "Tipo de archivo OK"
                Event.$emit('mostrar_alert', conf);
            }
            console.log('aceptado', aceptado);
        },

        rangoNumeros(texto) {
            const arreglo_rango = [];
            
            if(!texto) {
                return arreglo_rango;
            }
            const regex = /(\d+)/g;
            const rango = texto.match(regex);
            
            for(let i = parseInt(rango[0]); i <= parseInt(rango[rango.length - 1]); i++) {
                arreglo_rango.push(i);
            }
            return arreglo_rango;
        },

        formatearFechaExcel(fecha) {
            try {
                let fecha_nueva = fecha.split('/');
                if (fecha_nueva.length === 2) {
                    fecha_nueva = fecha_nueva[1].split('-');
                }
                return new Date(fecha_nueva[2], parseInt(fecha_nueva[1]) - 1, fecha_nueva[0]).toISOString().substring(0, 10);
            } catch (error) {
                return fecha;
            }
        },

        formatearFila(fila) {
            if(!this.colores[fila.lote]) {
                this.colores[fila.lote] = this.generarColor();
            }
            fila.color = this.colores[fila.lote];

            fila.seleccionado = {
                traslado: false,
                reensaque: false,
                venta: false,
            };

            fila.fecha_reensaque = this.formatearFechaExcel(fila.fecha_reensaque);
            fila.fecha_despacho = this.formatearFechaExcel(fila.fecha_despacho);

            fila.saldo = Number(fila.ton_traza) * 1000;

            fila.peso_maxisaco = `${fila.formato * 1000}`;
            fila.formato_maxisaco = this.formatos_maxisacos.find(formato => formato.formato == fila.peso_maxisaco).id;

            fila.maxis_options = this.rangoNumeros(fila.maxis);
            fila.maxis_seleccionados = [...fila.maxis_options];

            fila.nro_maxis_2_options = this.rangoNumeros(fila.nro_maxis_2);
            fila.nro_maxis_2_seleccionados = [...fila.nro_maxis_2_options];

            return fila;
        },

        seleccionar(item, seleccion) {
            if(seleccion === 'traslado') {
                const seleccionado = item.seleccionado.traslado;
                Object.keys(item.seleccionado).forEach(key => {
                    item.seleccionado[key] = seleccionado; 
                });
            }

            if(seleccion === 'reensaque') {
                if(!item.seleccionado.reensaque) {
                    item.seleccionado.venta = item.seleccionado.reensaque;
                }
            }
        },

        generarColor() {
            const colores = [];
            colores.length = 3;

            for(let i = 0; i < colores.length; i++) {
                colores[i] = Math.round(Math.random() * 255);
            }

            const color = `rgba(${colores[0]}, ${colores[1]}, ${colores[2]}, 0.2)`
            return color;
        },

        async cargarFormatos() {
            this.mostrarLoading({ titulo: 'Cargando Formatos...', color: 'green' })
            const url = `${this.base_url}traza/formato_maxisacos`;
            await this.axios.get(url, this.headers).then(res =>{
                console.log("maxisacos: ", res.data.data)
                this.ocultarLoading();
                this.formatos_maxisacos = res.data.data;
            }).catch(error => {
                console.log('error',error);
                this.ocultarLoading();
            });
        },

        async cargarDocumentos(){
            await this.axios.get(`${this.base_url}mov_documentos?tipo_movimiento=S&motivo_movimiento=5&tipo_produccion_id=1&limit=99999999`,this.headers).then(res => {
                const documentos = res.data.data.data;
                documentos.forEach(d => {
                    this.mov_documentos.push({
                        mov_documentos_id:d.id,
                        valor_dato:'',
                        tipo_dato:d.tipo_dato_texto,
                        documento:d.documento,
                        opciones:d.opciones
                    });
                });
                console.log(this.mov_documentos);
            }).catch(e => {
                console.log(e);
            });
        },

        async importarDatos() {
            this.mostrarLoading({ titulo: 'Subiendo Archivo...', color: 'green' })

            //subiendo el archivo
            const token = this.headers.headers['Authorization'];
            const cabecera = {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'multipart/form-data',
                }
            }
            const body = new FormData();
            body.append('archivo', this.archivo);
            
            const url = `${this.base_url}traza/subir_archivo`;
            console.log('headers',cabecera);

            await this.axios.post(url, body, cabecera).then((res) =>{
                this.url_archivo = res.data.nombre;
                this.ocultarLoading();
                this.enviarNombreArchivo(res);
            }).catch((error) =>{
                console.log('error',error);
                conf.tipo = "error";
                conf.mensaje = `No se ha subido archivo`;
                Event.$emit('mostrar_alert',conf);
                this.ocultarLoading();
            });
        },

        async enviarNombreArchivo(res){
            console.log('cabecerita', this.headers);
            console.log('res archivo', res);
            this.mostrarLoading({ titulo:'Procesando Datos...',color:'green' })
            const url = `${this.base_url}traza/importar_traza`;
            const body = {
                nombre_archivo: this.url_archivo,
                skip: this.skip,
                limit: this.limit,
            }
            const conf = {};
            // Enviando nombre de archivo
            await this.axios.post(url,body,this.headers).then(res => {
                console.log('Response datos:', res.data);
                conf.tipo = "success";
                conf.mensaje = res.data.success;
                Event.$emit('mostrar_alert',conf);
                this.datos = res.data.data.map(fila => this.formatearFila(fila));
                //this.limpiar();
                this.ocultarLoading();
            }).catch(error => {
                console.log('error',error);
                conf.tipo = "error";
                conf.mensaje = `No se ha podido leer los datos`;
                Event.$emit('mostrar_alert',conf);
                this.ocultarLoading();
            });
        },

        async obtenerLotesRestantes(item){
            this.mostrarLoading({ titulo:`Obteniendo registros restantes de lote ${item.lote}...`,color:'green' })
            const url = `${this.base_url}traza/importar_traza`;
            const filas = this.datos.filter(dato => dato.lote === item.lote).map(dato => dato.id);
            const body = {
                nombre_archivo: this.url_archivo,
                lote: {
                    nro: item.lote,
                    filas,
                },       
            }
            console.log(body);
            const conf = {};
            // Enviando nombre de archivo
            await this.axios.post(url,body,this.headers).then(res => {
                console.log('Response datos lote:', res.data);
                conf.tipo = "success";
                conf.mensaje = res.data.success;
                Event.$emit('mostrar_alert',conf);
                const nuevos_datos = res.data.data.map(fila => this.formatearFila(fila));
                this.datos = [
                    ...this.datos,
                    ...nuevos_datos,
                ];
                //this.limpiar();
                this.ocultarLoading();
            }).catch(error => {
                console.log('error',error);
                conf.tipo = "error";
                conf.mensaje = `No se han podido obtener datos de lote ${item.lote}`;
                Event.$emit('mostrar_alert',conf);
                this.ocultarLoading();
            });
        },

        async guardarRegistros() {
            this.mostrarLoading({ titulo: 'Importando Datos...', color: 'green' })
            const datos_seleccionados = this.datos.filter(dato => {
                if(dato.seleccionado.traslado) {
                    dato.peso_maxisaco = this.formatos_maxisacos.find(formato => formato.id === dato.formato_maxisaco).formato;
                    if(!dato.leyenda) dato.leyenda = this.leyendas[dato.lote];
                    dato.nuevo_lote = this.nuevo_lote[dato.lote];
                    return true;
                } else {
                    return false;
                }
            });
            console.log(datos_seleccionados);
            const conf = {};
            const url = `${this.base_url}traza/guardar_info`;
            await this.axios.post(url, datos_seleccionados, this.headers).then(res => {
                console.log('Response datos:', res);
                
                conf.tipo = "success";
                conf.mensaje = "Datos importados exitosamente";
                Event.$emit('mostrar_alert',conf);
                //this.limpiar();
                this.ocultarLoading();
            }).catch(error => {
                console.error('error',error);
                conf.tipo = "error";
                conf.mensaje = `No se han podido importar los datos`;
                Event.$emit('mostrar_alert',conf);
                this.ocultarLoading();
            });
        },

        limpiar(){
            this.archivo = {};
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        desactivar_importar(){
            if(this.archivo != {}){
                const aceptado = this.formatos_aceptados.find(formato => formato === this.archivo.type);
                if((aceptado == undefined) || (!this.skip)){
                    return true;
                } else {
                    return false;
                }
            }

            return true;
        },
        nuevos_datos() {
            const lotes = [];
            const nuevos_datos = this.datos.map(dato => {
                if(dato.maxis_seleccionados.every(maxi => dato.nro_maxis_2_seleccionados.includes(maxi)) && dato.maxis_seleccionados.length === dato.nro_maxis_2_seleccionados.length && !lotes.includes(dato.lote)) {
                    this.$set(this.nuevo_lote, dato.lote, false);
                } else {
                    lotes.push(dato.lote);
                    this.$set(this.nuevo_lote, dato.lote, true);
                }
                return dato;
            })
            return nuevos_datos;
        },
        ...mapState(['base_url','headers'])
    },
    components:{
        'alert':Alert,
        DatePicker
    }
}
</script>
<style>
.lote-inexistente {
    background-color: #f4b1b1 !important;
}

.cabecera-traslado {
    background-color: orange !important;
}

.cabecera-reensaque {
    background-color: green !important;
}

.cabecera-saldo {
    background-color: skyblue !important;
}
</style>